import { getStore } from 'cadenza/store/cadenza-store';
import type { DataViewId } from 'cadenza/workbook/model/data-view-id.gen';
import { getAttributesFromBundles } from 'cadenza/workbook/workbook-core-selectors.state';

export function getColorClassificationAttribute(dataViewId: DataViewId) {
  return getAttributesFromBundles(getStore().getState(), dataViewId, 'COLOR_CLASSIFICATION').at(0);
}

export function getSubcategoryAttribute(dataViewId: DataViewId) {
  return getAttributesFromBundles(getStore().getState(), dataViewId, 'SUB_CATEGORY').at(0);
}

export function getCategoryAttribute(dataViewId: DataViewId) {
  return getAttributesFromBundles(getStore().getState(), dataViewId, 'DIMENSION').at(0);
}
